<template>
  <breadCrumbs title="Checkout" main="Ecommerce" title1="Checkout" />
  <div class="container-fluid">
    <div class="card checkout">
      <div class="card-header pb-0">
        <h3>Billing Details</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <billingForm />
          <checkoutDetail />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import billingForm from "./billingForm.vue"
import checkoutDetail from "./checkoutDetail.vue"
export default {
  name: 'checkoutView',
  components: { billingForm, checkoutDetail },
}
</script>